<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <treeselect v-model="selected" :options="options" :multiple="true"
                :value-consists-of="'LEAF_PRIORITY'" :limit="5" @input="input"
                :noChildrenText="noChildrenText" :noResultsText="noResultsText"
                :noOptionsText="noOptionsText" :placeholder="placeholder" :loading-text="loadingText"
                :retryText="retryText" :retryTitle="retryTitle" :searchPromptText="searchPromptText"
    ></treeselect>
  </b-form-group>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import i18n from '@/i18n';
import getUserLocale from 'get-user-locale';

export default {
  name: "DropdownMultiple",
  components: {Treeselect},
  props: {
    options: Array,
    model: Object,
    attribute: {
      type: String,
      default: 'user'
    },
    field: {
      type: String,
      default: '_id'
    },
    multiple: Boolean,
    label: {
      type: String,
    },
    noChildrenText: {
      type: String,
      default: i18n.t('noUsersInThisGroup')
    },
    noOptionsText: {
      type: String,
      default: i18n.t('noOptionsText')
    },
    noResultsText: {
      type: String,
      default: i18n.t('noResultsText')
    },
    placeholder: {
      type: String
    },
    retryText: {
      type: String,
      default: i18n.t('retryText')
    },
    retryTitle: {
      type: String,
      default: i18n.t('retryTitle')
    },
    searchPromptText: {
      type: String,
      default: i18n.t('loading')
    },
    loadingText: {
      type: String,
      default: i18n.t('loading')
    },
    errors: Array,
    groupsFilter: Array
  },
  data() {
    return {
      errorTxt: '',
      selected: [],
      state: null,
    }
  },
  methods: {
    input() {
      if (this.selected && this.selected.length) {
        this.model[this.attribute] = this.selected
      } else {
        this.model[this.attribute] = null
      }
      this.$emit('change');
    },
    loadSelected() {
      if (this.model[this.attribute]) {
        this.selected = this.model[this.attribute]
      } else {
        this.selected = []
      }
    }
  },
  watch: {
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  mounted() {
    this.loadSelected();
    let locale = localStorage.getItem('locale');
    if (!locale) {
      locale = getUserLocale().split('-')[0];
    }
    i18n.locale = locale;
  }
}
</script>

<style scoped>

</style>